import React from 'react';
import { Skeleton } from 'antd';
import CardContainer from '../CardContainer';
import Wrapper from '../Wrapper';
import './InfoCard.less';

const InfoCardSkeleton: React.FC = () => {
  return (
    <CardContainer>
      <div className="t-skeleton-info-card-container">
        <Wrapper mr={1}>
          <Skeleton.Avatar active className="t-skeleton-cover-image-skeleton" />
        </Wrapper>
        <Skeleton round active paragraph={{ rows: 2 }} />
      </div>
    </CardContainer>
  );
};

export default InfoCardSkeleton;
